import BlockStack from "./BlockStack";
import EmptyState from "./EmptyState";
import Spinner from "./Spinner";

const LoadingPage = () => {
  return (
    <div className="flex items-center justify-center h-screen">
      <EmptyState image="/images/svg/glide-logo.svg">
        <BlockStack gap="400" inlineAlign="center">
          <div style={{ marginTop: 20 }} />
          <h1 className="text-xl! text-bold">Loading Glide</h1>
          <p>
            Our platform helps you to fulfil orders for custom products better
            than ever. Including; quoting, proofing, manufacturing, shipping and
            more.
          </p>
          <Spinner className="text-black" />
        </BlockStack>
      </EmptyState>
    </div>
  );
};

export default LoadingPage;
